export default {
  scrollBehavior() {
    return { top: 0 };
  },
  sensitive: true,
};
